import { useNavigate } from 'react-router-dom';

import { PROCEDURE_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const useProcedureParamsListActions = (id: string | number) => {
    const navigate = useNavigate();

    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        navigate(`${PROCEDURE_EDIT}/${id}`);
    };

    return {
        handleEdit,
    };
};
